import { create } from "./create"
import { update } from "./update"

export const studySession = {
  create,
  update,
}
